import request from '@/api/request';

export function getNotifications (params) {
  return request({
    url: '/notification',
    method: 'get',
    params
  });
}

export function getUnreadNotifications () {
  return request({
    url: '/notification',
    method: 'get',
  });
}

export function getNotificationDetail (id) {
  return request({
    url: '/notification/detail',
    method: 'get',
    params: {
      id
    }
  });
}

export function getNews (params) {
  return request({
    url: '/notification/news',
    method: 'get',
    params
  });
}

export function getWarning (params) {
  return request({
    url: '/notification/warning',
    method: 'get',
    params
  });
}

export function markAllNotificationAsRead () {
  return request({
    url: '/notification/markallasread',
    method: 'put',
  });
}

export function deleteNotifications (data) {
  return request({
    url: '/notification/delete',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/notification.js